<template>
  <div class="lang-wrapper">
    <ecogas-menu
      :status="['menu', 'contacts-request', 'brochure-request', 'location'].includes($route.meta.pageName)"
      :lang="lang"
      :fast-white="['processings', 'privacy-policy', 'not-found'].includes($route.meta.pageName)"
      :background-hamburger="['location'].includes($route.meta.pageName)"/>

    <transition
      :name="transitionName"
      :mode="mode"
      v-on:after-leave="afterLeave"
      v-on:before-enter="beforeEnter">
      <router-view :lang="lang" />
    </transition>

    <!-- <contacts-location-cta v-show="showCta" :lang="lang"/> -->
    <partners :lang="lang"/>
    <ecogas-footer v-show="showFooter" :lang="lang"/>
    <!-- <CookieBar :lang="lang"/> -->
    <check-touch />
  </div>
</template>

<script>
import EcogasMenu from '@/components/EcogasMenu'
import EcogasFooter from '@/components/EcogasFooter'
import Partners from '@/components/Partners'
// import ContactsLocationCta from '@/components/ContactsLocationCta'
// import CookieBar from '@/components/CookieBar'
import CheckTouch from '@/components/CheckTouch'
export default {
  components: {
    EcogasMenu,
    EcogasFooter,
    Partners,
    // ContactsLocationCta,
    // CookieBar,
    CheckTouch
  },
  data: () => ({
    inMenu: false,
    transitionName: undefined,
    mode: undefined,
    transitionMap: {
      menu: 'menu-transition',
      cta: 'cta-transition'
    },
    hideFooter: false,
    hideCta: false
  }),
  props: {
    lang: {
      type: String,
      default: () => 'en'
    }
  },
  async mounted () {
    /* const fase = await this.$apollo.provider.defaultClient.query({
        client: 'dato',
        query: faseLocale,
        variables: {
          locale: this.$i18n.locale,
          slug: 'stoccaggio'
        },
      })
      .then(({ data }) => data)

      console.log(fase)
   */
  },
  methods: {
    afterLeave (el) {
      /*
      if (['menu', 'contacts', 'contacts-request', 'location'].includes(this.$route.meta.pageName)) { this.hideFooter = true }
      if (['menu', 'contacts-request', 'location', 'success', 'failure', 'company', 'sectors'].includes(this.$route.meta.pageName)) { this.hideCta = true }
      */
    },
    beforeEnter (el) {
      /*
      if (!['menu', 'contacts', 'contacts-request', 'location'].includes(this.$route.meta.pageName)) { this.hideFooter = false }
      if (!['menu', 'contacts-request', 'location', 'success', 'failure', 'company', 'sectors'].includes(this.$route.meta.pageName)) { this.hideCta = false }
      */
    },
    $_hideShowComponents (pageName) {
      // hide e show dei blocch in footer
      if (['menu', 'contacts-request', 'brochure-request', 'location'].includes(pageName)) this.hideFooter = true
      else this.hideFooter = false
      if (['menu', 'contacts-request', 'brochure-request', 'location', 'success', 'failure'].includes(pageName)) this.hideCta = true
      else this.hideCta = false
    }
  },
  computed: {
    showFooter: {
      get () {
        return !this.hideFooter
      }
    },
    showCta: {
      get () {
        return !this.hideCta
      }
    }
  },
  watch: {
    '$route': {
      handler (newRoute, oldRoute) {
        if (newRoute.meta.pageName === 'menu' || ['menu', 'contacts-request', 'brochure-request', 'location'].includes(oldRoute.meta.pageName)) {
          this.transitionName = this.transitionMap.menu
          this.mode = newRoute.meta.pageName === 'menu' ? 'in-out' : undefined
          return
        }

        if (['contacts-request', 'brochure-request', 'location'].includes(newRoute.meta.pageName)) {
          this.transitionName = this.transitionMap.cta
          this.mode = ['contacts-request', 'brochure-request', 'location'].includes(newRoute.meta.pageName) ? 'in-out' : undefined
          return
        }

        this.transitionName = undefined
        this.mode = undefined
      }
    },
    lang: {
      async handler (lang) {
        this.$i18n.locale = lang
        this.$validator.localize(lang)
      },
      immediate: true
    }
  }
}
</script>

<style>

.cta-transition-enter {
  transform: translate3d(0, 100%, 0);
}

.cta-transition-enter-to {
  transform: translate3d(0, 0, 0);
}

.cta-transition-enter-active {
  transition: all 600ms cubic-bezier(0.23, 1, 0.32, 1);
  top: 0;
}

.cta-transition-leave {
  transform: translate3d(0, 0, 0);
}

.cta-transition-leave-to {
  transform: translate3d(0, 100%, 0);
}

.cta-transition-leave-active {
  transition: all 600ms cubic-bezier(0.23, 1, 0.32, 1);
}

</style>
